export var getIds = id => id ? {
  root: id,
  leftContainer: "".concat(id, "__left-container"),
  icon: "".concat(id, "__icon"),
  itemLabel: "".concat(id, "__item-label"),
  rightContainer: "".concat(id, "__right-container"),
  value: "".concat(id, "__value")
} : undefined;
//# sourceMappingURL=getIds.js.map